// @ngInject
function printInvoiceDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(message, level) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'printInvoiceDialogController as vm',
            templateUrl: 'services/dialogs/printInvoiceDialog/printInvoiceDialog.tpl.html',
            size: 'md'
        };

        modalDefaults.resolve = {
            message: function() {
                return message;
            },
            level: function() {
                return level;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function printInvoiceDialogController($uibModalInstance, message, level, $sce) {
    var vm = this;

    //Properties
    vm.message = $sce.trustAsHtml(message);
    vm.level = level;
    vm.printLanguage = 'en';
    vm.weightSetting = 'kg';

    //Methods
    vm.closeModal = closeModal;
    vm.setLanguage = setLanguage;
    vm.setWeightSetting = setWeightSetting;

    function closeModal(isCompleted) {
        var result = {
            result: isCompleted,
            languageCode: vm.printLanguage,
            weightSetting: vm.weightSetting
        };
        $uibModalInstance.close(result);
    }

    function setLanguage(language) {
        vm.printLanguage = language;
    }
    function setWeightSetting(setting) {
        vm.weightSetting = setting;
    }
}

angular
    .module('services.dialogs.printInvoiceDialog', [])
    .service('printInvoiceDialogService', printInvoiceDialogService)
    .controller('printInvoiceDialogController', printInvoiceDialogController);
